package com.mps.asc_app.domain.places.usecase

import com.mps.asc_app.data.places.PlacesRepository
import com.mps.asc_app.data.places.model.AddressSuggestion

class AutocompleteAddressUseCase(
    private val placesRepository: PlacesRepository
) {
    suspend operator fun invoke(query: String): List<AddressSuggestion> {
        if (query.length < 3) return emptyList()
        return placesRepository.autocomplete(query)
    }
}